/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ChatListFilterType = {
    Unread: 'unread',
    Groups: 'groups',
    Favorites: 'favorites'
} as const;
export type ChatListFilterType = typeof ChatListFilterType[keyof typeof ChatListFilterType];

